// 默认利用axios的cancelToken进行防重复提交。
// 如需允许多个提交同时发出。则需要在请求配置config中增加 neverCancel 属性，并设置为true

import axios from "axios";
import { axiosConfig, interceptorsConfigs } from "../config/axios";
import { AxiosRequestConfig, Canceler } from "axios";
// import store from '../store/index';
// import { getSessionId } from '@/utils/auth';

/* 防止重复提交，利用axios的cancelToken */
const pending = new Set<string>(); // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识

const CancelToken = axios.CancelToken;

//不重复发送同一请求 如果有就
const removePending = (config: AxiosRequestConfig, canceler?: Canceler) => {
  const flagUrl = config.url;
  if (flagUrl) {
    if (pending.has(flagUrl)) {
      if (canceler) canceler("Cancel same request");
      else pending.delete(flagUrl);
    } else if (canceler) pending.add(flagUrl);
  }
};

/* 创建axios实例 */
const service = axios.create(axiosConfig);

/* request拦截器 */
service.interceptors.request.use(
  (config) => {
    if (!interceptorsConfigs.allowDuplicateRequest)
      config.cancelToken = new CancelToken((c) => {
        removePending(config, c);
      });
    //to be done

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

/* response拦截器 */
service.interceptors.response.use(
  (response) => {
    if (!interceptorsConfigs.allowDuplicateRequest)
      removePending(response.config);

    //to be done
    return response;
  },
  (error) => {
    // 异常处理
    console.log(error);
    pending.clear();
    if (error.message === "Cancel same request") {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default service;
